import * as React from 'react';
import RedwoodModal from '../../../common/Modal/RedwoodModal';
import promotionsData from '../../../data/PromotionsInfo';
import {Context} from '../../../state/Store';
import * as _ from 'lodash';
import countries from '../../../data/CountriesInfo';
import { getOrgId } from '../../Helpers';
import {useTranslation} from "react-i18next";
import SendAction from '../../../CourierService/SendAction';
import SendLogs from '../../../CourierService/SendLogs';
import SendMetrics from '../../../CourierService/SendMetrics';
import {navTrack} from '../../../config/adobeAnalytics';
import {removeSpace} from './../../../components/Helpers';
import {fetchPromotionGuests, fetchStateId, fetchValidateEmail} from "../../../CourierService/FetchService";


const PromoDialog = (props) => {
  const {emailVerification, verifyEmailBtnClicked, captchaJwtToken, promoAvailablecheck} = props;
  const {t} = useTranslation();
  const [state, dispatch] = React.useContext(Context);
  const [show, setShow] = React.useState(false);
  const [selectedPromo, setSelectedPromo] = React.useState({});
  const [promoList, setPromoList] = React.useState([]);
  const currency = state.countryInfo !== undefined && state.countryInfo.currency !== undefined ? state.countryInfo.currency.symbol : '$';
  const countrySpecificPromos = ['Standard', 'Developer', 'Student', 'Educator', 'STARTUP', 'ARM-OCI'];
  const [promoRetries, setPromoRetries] = React.useState(0);
  const [validateEmailRetries, setValidateEmailRetries] = React.useState(0);

  const toggleModal = () => {
    setShow(!show);
    props.toggleCallBack();
  }

  const selectOffer = () => {
    setShow(!show);
    dispatch({
      type: "UPDATE_PROMO",
      payload: selectedPromo
    });

    if(!_.isEmpty(selectedPromo.address)) {
      dispatch({
        type: 'UPDATE_PROMO_ADDRESS',
        payload: selectedPromo.address
      });
    }
    const isProvinceFlag = selectedPromo.address.province ? true : false;
    const stateOrProvince = isProvinceFlag ? selectedPromo.address.province : selectedPromo.address.state;
    getStateId(selectedPromo.country, stateOrProvince, isProvinceFlag);

    if(!_.isEmpty(selectedPromo.firstName)) {
      dispatch({
        type: 'UPDATE_FIRST_NAME',
        payload: selectedPromo.firstName
      });
      props.resetError('firstName');
    }

    if(!_.isEmpty(selectedPromo.lastName)) {
      dispatch({
        type: 'UPDATE_LAST_NAME',
        payload: selectedPromo.lastName
      });
      props.resetError('lastName');
    }
    
    if(!_.isEmpty(selectedPromo.customerName)) {
      dispatch({
        type: 'UPDATE_ORG',
        payload: selectedPromo.customerName
      });
    }
    if(!_.isEmpty(selectedPromo.country)) {
      const countryObject = {'value': selectedPromo.country, label: t('countries.' + selectedPromo.country)};
      dispatch({
        type: 'UPDATE_PROMO_COUNTRY',
        payload: countryObject
      })
      const countryInfo = countries.countries[selectedPromo.country];
      if(countryInfo === undefined) {
        dispatch({
          type: 'UPDATE_COUNTRY',
          payload: ['', countryObject, {}, '', '']
        });
      } else {
        const orgId = getOrgId(countryInfo.tc.OrgName);
        dispatch({
          type: 'UPDATE_COUNTRY',
          payload: [selectedPromo.country, countryObject, countryInfo, orgId]
        });
      }
    }

    if(!selectedPromo.creditCardRequired) {
      navTrack('oci-signup', state.language, 's1-selected-promo', 'credit-card-not-required');
    }

    if(selectedPromo.creditCardRequired && state.isOpayOutage){
      dispatch({
        type: "UPDATE_SHOW_BANNER",
        payload: true,
      });
      props.toggleCallBack();
    }


    if(selectedPromo.promoId !== undefined) {
      navTrack('oci-signup', state.language, 's1-selected-promo', 'user-selected-a-promo')
      navTrack('oci-signup', state.language, 's1-selected-promo', `promo-type: ${selectedPromo.type}`)
      navTrack('oci-signup', state.language, 's1-selected-promo', `program-type: ${selectedPromo.programType}`)
      SendAction({action: 'promo_selected', value: 'selected promo: ' + JSON.stringify(selectedPromo), userSession: state.user_session});
    }

    if(selectedPromo.programType === 'SE-TRIAL'){
      props.updateSETrialAccountName(selectedPromo.customerName);
    }

    toggleModal();
  };

  const getStateId = (country, selectedState, isProvinceFlag) => {
    let statesList = [];
    let selectedPromoState = null;
    if (country !== "" && selectedState !== "") {
      fetchStateId(country)
      .then(async (res) => {
        if (res.status === 200) {
          statesList = await res.json();
          statesList != null &&
          statesList.items.map((state) => {
            if(_.toUpper(selectedState) === _.split(state.id, '-')[1]) {
              selectedPromoState = { value: { id: state.id }, label: state.name };}
            return selectedPromoState;
          });
          if(isProvinceFlag) {
            selectedPromo.address.selectedProvince = selectedPromoState;
          } else {
            selectedPromo.address.selectedState = selectedPromoState;
          }
          dispatch({
            type: 'UPDATE_PROMO_ADDRESS',
            payload: selectedPromo.address
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  }

  const setApiError = () => {
    dispatch({
      type:'UPDATE_APIERROR',
      payload: true
    });
  };

  React.useEffect(() => {
    dispatch({
      type: "UPDATE_PROMO",
      payload: {}
    });
  }, [props.email.value])
   
  //GET promotion guests with email
  let promotions = [];
  React.useEffect(() => {
    if(props.email.value !== '' && state.username !== '' && verifyEmailBtnClicked >= 1) {
      emailVerification(true);
      fetchPromotionGuests(encodeURIComponent(state.username), captchaJwtToken)
      .then(async res => {
        emailVerification(false);
        if(res.status === 200) {
          const results = await res.json();
          promotions = results.items;
          dispatch({
            type: "UPDATE_PROMOTIONS",
            payload: promotions
          });
          if(results.items.length !== 0) {
            promoAvailablecheck(true, state.username);
            makePromoObject(results.items);
            toggleModal();
            props.updateAccountName(state.username);
            dispatch({
              type: 'VALIDATE_EMAIL',
              payload: true
            });
          }
          SendMetrics({name:"PromotionGuests.Count.Metrics", value:1, userSession:state.user_session});
        } else if(res.status === 400) {
          SendMetrics({name:"PromotionGuests.Count.Metrics.Error", value:1, userSession:state.user_session});
        }
        else if(res.status >= 500){
          SendMetrics({name:"PromotionGuests.Count.Metrics.Error", value:1, userSession:state.user_session});
          if(promoRetries === 3){
            setApiError();
          } else{
            setPromoRetries(promoRetries + 1);
          }
        }
      })
      .then(() => {
        if(promotions.length === 0) {
          emailVerification(true);
          promoAvailablecheck(false, state.username);
         fetchValidateEmail(
             JSON.stringify({
               "username": state.username,
               "validationAttributes": [{
                 "operationItemDefinitionId": "OIH-PROMOCM-CREATE_V2"
               }]
             })
          )
          .then(async res => {
            emailVerification(false);
            if(res.status === 204){
              props.sendVerificationLink();
            } else if(res.status === 409) {
              navTrack("oci-signup", state.language, "s1-entered-email", "existing-email");
              props.updateAccountListing(true, false, false);
              props.updateEmailError(false, '', 'It looks like you are already registered.');

            } else if(res.status === 400) {
              const result = await res.json();
              SendMetrics({name:"Email.Count.Metrics.Error", value:1, userSession:state.user_session});
              if(_.startsWith(result.message, 'Invalid email')) {
                props.updateEmailError(false, '', 'Invalid email entered');
              }
            } else if(res.status >= 500){
              SendMetrics({name:"Email.Count.Metrics.Error", value:1, userSession:state.user_session});
              if(validateEmailRetries === 3){
                setApiError();
              } else{
                setValidateEmailRetries(validateEmailRetries + 1);
              }
            }
            SendMetrics({name:"Email.Count.Metrics", value:1, userSession:state.user_session});
          }).catch(error => {
            console.log(error);
            SendLogs({severity: 40000, message: "POST Email or GET PromotionGuests error " + error.message, userSession:state.user_session});
            SendMetrics({name:"Email_PromotionGuests.Count.Metrics.Fail", value:1, userSession:state.user_session});

          })
        }})
        
      .catch(error => {
        console.log(error);
      });
    }},
    [promoRetries, validateEmailRetries, verifyEmailBtnClicked]
  );

  let promoResult = [];
  const makePromoObject = (promotions) => {
    const data = promotions;

    data.map((promo) => {
      let promotion = {};
      const firstName = promo.guest.firstName;
      const lastName = promo.guest.lastName;
      const promoAttributes = _.isEmpty(promo.operationItems) ? [] :  promo.operationItems[0].attributes;
      const promoAmtIndex = _.findIndex(promoAttributes, function(o) {
        return o.name === 'promoAmount';
      });
      const promoDaysIndex = _.findIndex(promoAttributes, function(o) {
        return o.name === 'promoDurationInDays'
      });
      const promoCampaignId = _.findIndex(promoAttributes, function(o) {
        return o.name === 'campaignId';
      });
      const creditCardRequired = _.findIndex(promoAttributes, function(o) {
        return o.name === 'creditCardRequired';
      });
      const validationCodeRequired = _.findIndex(promoAttributes, function(o) {
        return o.name === 'validationCodeRequired';
      });
      const campaignDisplayName = _.findIndex(promoAttributes, function(o) {
        return o.name === 'campaignDisplayName';
      });
      const customerName = _.findIndex(promoAttributes, function(o) {
        return o.name === 'customerName';
      });
      const programType = _.findIndex(promoAttributes, function(o) {
        return o.name === 'programType';
      });
      const country = _.findIndex(promoAttributes, function(o) {
        return o.name === 'country';
      })
      const intendedUse = _.findIndex(promoAttributes, function(o) {
        return o.name === 'cloudUI.default.intendedUse';
      })
      const customerNameNotDefault = _.findIndex(promoAttributes, function(o) {
        return o.name === 'customerNameNotCloudUiDefault'
      })
      let address = {};

      _.map(promoAttributes, attribute => {
        if(attribute.name === 'address1') {
          address.address1 = attribute.value;
        } else if(attribute.name === 'address2') {
          address.address2 = attribute.value;
        } else if(attribute.name === 'address3') {
          address.address3 = attribute.value;
        } else if(attribute.name === 'address4') {
          address.address4 = attribute.value
        } else if(attribute.name === 'city') {
          address.city = attribute.value;
        } else if(attribute.name === 'state') {
          address.state = attribute.value;
        } else if(attribute.name === 'province') {
          address.province = attribute.value;
        } else if(attribute.name === 'postalCode') {
          address.postalcode = attribute.value
        } else if(attribute.name === 'county') {
          address.county = attribute.value;
        }
      });

      
      promotionsData.items.filter(function(promoDefinition) {
        if(promo.promotion.partNumber === promoDefinition.partNumber ) {
          promotion = JSON.parse(JSON.stringify(promoDefinition));
          const promoId = promo.id;
          promotion.promoId = promoId;
          promotion.campaignId = promoCampaignId === -1 ? "" : promoAttributes[promoCampaignId].value;  
          promotion.promoAmount = promoAmtIndex === -1 ? promoDefinition.promoAmount : promoAttributes[promoAmtIndex].value;
          promotion.promoDurationInDays = promoDaysIndex === -1 ? promoDefinition.promoDurationInDays : promoAttributes[promoDaysIndex].value;
          promotion.creditCardRequired = creditCardRequired === -1 ? promoDefinition.creditCardRequired : _.toLower(promoAttributes[creditCardRequired].value) === 'false' ? false : true;
          promotion.validationCodeRequired = validationCodeRequired === -1 ? promoDefinition.validationCodeRequired : _.toLower(promoAttributes[validationCodeRequired].value) === 'false' ? false : true;
          promotion.campaignDisplayName = campaignDisplayName === -1 ? '' : promoAttributes[campaignDisplayName].value;
          promotion.customerName = customerName === -1 ? '' : promoAttributes[customerName].value;
          promotion.address = _.isEmpty(address) ? {} : address;
          promotion.programType = programType === -1 ? '' : promoAttributes[programType].value;
          promotion.country = country === -1 ? '' : promoAttributes[country].value;
          promotion.currency = country === -1 ? currency : '$';
          promotion.firstName = _.isEmpty(firstName) ? '' : firstName;
          promotion.lastName = _.isEmpty(lastName) ? '' : lastName;
          promotion.intendedUse = intendedUse === -1 ? '' : promoAttributes[intendedUse].value;
          promotion.customerNameNotDefault = customerNameNotDefault === -1 ? '' : promoAttributes[customerNameNotDefault].value;
          promotion.promoAmount = promotion.promoAmount === '0' ? promoDefinition.promoAmount : promotion.promoAmount;
          promotion.promoDurationInDays = promotion.promoDurationInDays === '0' ? promoDefinition.promoDurationInDays : promotion.promoDurationInDays;
         } 
      });
      promoResult.push(removeSpace(promotion));
    })
    setPromoList(promoResult);
    promoResult.length !== 0 && setSelectedPromo(promoResult[0]);
  };

  const onPromoChange = (promo) => {
    setSelectedPromo(promo);
  };

  return (
    <RedwoodModal testId="promo-dialog-modal" onClose={e => {selectOffer();}} show={show} title={t('promo.specialOfferTitle')} buttonName={t('promo.selectOfferButton')}>
      <p>{t('promo.welcome')} <strong>{state.username}.</strong></p>
      <p>{t('promo.promoDialog1')}:</p>
      <div>
        {promoList.map((promo) => {
          return (
            <div>
              <label key={promo.promoId}>
                <input type="radio" checked={selectedPromo.promoId === promo.promoId} onChange={e => onPromoChange(promo)} value={promo.promoId} />
                {_.isEmpty(promo.customerName) ? '' : promo.customerName + ' -'} For {promo.campaignDisplayName === '' ? promo.type: promo.campaignDisplayName} with {promo.currency}{state.countryInfo !== undefined && _.findIndex(countrySpecificPromos, function(o) { return o === promo.type;}) !== -1 ? state.countryInfo.promos[promo.type]: promo.promoAmount} credits for {promo.promoDurationInDays} days
              </label> 
              <br />
            </div>
          )
        })}
      </div>
    </RedwoodModal>
  )
}

export default PromoDialog;
